import styled from "styled-components"

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000;
`

export const VideoElement = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  background: #000;

  /* Ensure video is visible and not transparent */
  opacity: 1;
  visibility: visible;

  /* iOS specific fixes */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
`

export const HiddenCanvas = styled.canvas`
  display: none;
`

export const ErrorContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  padding: var(--spacing_l, 16px);
  background: rgba(0, 0, 0, 0.9);
  border-radius: 8px;
  width: calc(100% - 48px);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--spacing_l, 16px);

  svg {
    flex-shrink: 0;
  }
`

export const ErrorTitle = styled.h2`
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--Primitive-White, #fff);
  text-align: center;
  line-height: 140%;
  margin-bottom: 0;
`

export const ErrorText = styled.p`
  margin: 0 0 20px 0;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  line-height: 20px;
  margin: 0;
  text-align: center;
`

export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  z-index: 100;
`

export const FlashOverlay = styled.div<{ $visible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 50;
  pointer-events: none;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  transition: opacity 150ms ease-out;
`
